/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
//   import config from "../../config/activateUser.config.json";
import notification from '../../config/notifications.config.json';
import axios from 'axios';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { ACTIVATE_USER } from '../../config/api/graphql';
import { vappContainer } from '@/application';

const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};

export interface activateUserProps {
  ids: any;
}

export interface IActivateUserMethods extends IPluginMethodMap {
  getActivateUser(args: activateUserProps): Promise<any>;
}

export class ActivateUserService implements IAgentPlugin {
  readonly methods: IActivateUserMethods;

  constructor() {
    this.methods = {
      getActivateUser: this.getActivateUser.bind(this),
    };
  }

  async getActivateUser(args: activateUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    try {
      if (client) {
        const res = await client.mutate({
          mutation: ACTIVATE_USER,
          variables: {
            vuid: args,
          },
          fetchPolicy: 'no-cache',
        });
        if (res?.data?.reactivateUser) {
          return {
            ...res?.data?.reactivateUser,
            notification: notification?.activateUserSuccess,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
